"use client";

import CountUp, { type CountUpProps } from "react-countup";

type AnimatedCounterProps = CountUpProps & {
  /** Backward-compatible alias used in existing widgets */
  value?: number;
};

export default function AnimatedCounter({
  value,
  end,
  duration = 2,
  prefix = "",
  suffix = "",
  start = 0,
  enableScrollSpy = true,
  scrollSpyOnce = true,
  ...countUpProps
}: AnimatedCounterProps) {
  const resolvedEnd = value ?? end ?? 0;

  return (
    <CountUp
      start={start}
      end={resolvedEnd}
      duration={duration}
      prefix={prefix}
      suffix={suffix}
      enableScrollSpy={enableScrollSpy}
      scrollSpyOnce={scrollSpyOnce}
      {...countUpProps}
    >
      {({ countUpRef }) => <span ref={countUpRef} />}
    </CountUp>
  );
}
